import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Phone } from "lucide-react";
import { ServiceForm } from "@/components/forms/ServiceForm";
import { MaskLines, Reveal } from "@/components/motion/Reveal";
import { COMPANY, IMG } from "@/data/site";

export const ServiceSection = ({ index = "06" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section id="service-request" ref={ref} className="relative overflow-hidden border-t border-white/5 bg-ink-900 py-28 lg:py-40" data-testid="service-section">
      <div className="container-x grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal><p className="eyebrow"><span className="text-slate-500">{index} —</span> Service</p></Reveal>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
            <MaskLines onView lines={[<>Need Service<span className="text-signal">?</span></>]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-400">Machine down? Send us the details and a photo. The more we know up front, the faster we can get it running again.</p>
            <a href={COMPANY.tel} className="btn-ghost mt-8 h-12 px-6 text-sm" data-testid="service-call-button"><Phone className="h-4 w-4 text-volt" /> Urgent? {COMPANY.phone}</a>
          </Reveal>
          <div className="relative mt-12 hidden h-[300px] overflow-hidden rounded-[28px] border border-white/5 lg:block">
            <motion.img style={{ y, scale: 1.25 }} src={IMG.tech} alt="Technician servicing equipment" className="absolute inset-0 h-full w-full object-cover grayscale" />
            <div className="absolute inset-0 bg-gradient-to-tr from-ink-950/80 via-transparent to-volt/10" />
          </div>
        </div>
        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="rounded-[28px] border border-white/10 bg-ink-800/60 p-6 backdrop-blur-xl sm:p-10">
            <ServiceForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
